var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#box_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.714 11.75H8v1.143h5.714V11.75ZM13.714 9.464H8v1.143h5.714V9.464ZM11.428 6.036h-1.142v2.286h1.143V6.036Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.714 7.179v8H16v-8h-3.428v1.143h2.285v5.714h-8V8.322h2.286V7.179H5.714ZM0 15.179h4.571v-8H0v8Zm3.429-6.857v5.714H1.143v-1.143h1.143V11.75H1.143v-1.143h1.143V9.464H1.143V8.322h2.286ZM5.714 6.035h3.429V4.892h3.428v1.143h3.43V1.464h-1.144V3.75h-8V1.464H5.714v4.571Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.607h5.714V1.464h-1.143V.321H6.857v1.143H8v1.143Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.857.321h-1.143v1.143h1.143V.321ZM5.714.321H4.571v1.143h1.143V.321ZM1.143.321v1.143H0v4.572h4.571V1.464H3.43V.321H1.143Zm2.286 4.572H2.286V3.75H1.143V2.607h2.286v2.286Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "box_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgBox;